import {pickBy} from 'lodash';

import {AppAction} from '../../appActions';
import {ResourceMap} from '../../appTypes';
import {ChatPrecogActionsEnum} from './chatPrecogsActions';

export type ChatPrecogState = ResourceMap<boolean>;

export function chatPrecogReducer(state: ChatPrecogState, action: AppAction): ChatPrecogState {
  switch (action.type) {
    case ChatPrecogActionsEnum.CHAT_PRECOG_UPDATED:
      return {...state, [action.payload.conversationId]: true};
    case ChatPrecogActionsEnum.CHAT_PRECOG_DELETED:
      return pickBy(state, (_, conversationId) => Number(conversationId) !== action.payload.conversationId);
    default:
      return state;
  }
}
